import {ChecklistItem} from 'yougile-model'

interface ChecklistItemWithPlaceholder extends ChecklistItem {
  placeholder?: true
}

const hasPlaceholder = (item: object): item is ChecklistItemWithPlaceholder => {
  if ('placeholder' in item) {
    return true
  }

  return false
}

export const isPlaceholder = (item: ChecklistItem): boolean => {
  if (hasPlaceholder(item)) {
    return !!item.placeholder
  }

  return false
}
export const deletePlaceholderFlag = (item: ChecklistItem): void => {
  if (hasPlaceholder(item)) {
    delete item.placeholder
  }
}

export const toPlaceholder = (
  item: ChecklistItem
): ChecklistItem & {placeholder: true} => ({
  ...item,
  placeholder: true
})
